import { render, staticRenderFns } from "./TradingViewChart.vue?vue&type=template&id=6830285e&scoped=true"
import script from "./TradingViewChart.vue?vue&type=script&lang=js"
export * from "./TradingViewChart.vue?vue&type=script&lang=js"
import style0 from "./TradingViewChart.vue?vue&type=style&index=0&id=6830285e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830285e",
  null
  
)

export default component.exports